import ImageScrollbar from './imageScrollbar.js'

export {ImageScrollbar as default}